import { render, staticRenderFns } from "./xizaokaRefund.vue?vue&type=template&id=220d4642&scoped=true&"
import script from "./xizaokaRefund.vue?vue&type=script&lang=js&"
export * from "./xizaokaRefund.vue?vue&type=script&lang=js&"
import style0 from "./xizaokaRefund.vue?vue&type=style&index=0&id=220d4642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d4642",
  null
  
)

export default component.exports